import { render, staticRenderFns } from "./SubQuestionType1.vue?vue&type=template&id=fdb779a8&scoped=true&"
import script from "./SubQuestionType1.vue?vue&type=script&lang=js&"
export * from "./SubQuestionType1.vue?vue&type=script&lang=js&"
import style0 from "./SubQuestionType1.vue?vue&type=style&index=0&id=fdb779a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb779a8",
  null
  
)

export default component.exports